'use client';

import { MenuItem } from '@mui/material';

const OPTION_LABEL = 'Membership Programme Terms';

interface MembershipProgrammeTermsOptionProps {
  closeMenu?: () => void;
  onOpenTermsDialog?: () => void;
}

const MembershipProgrammeTermsOption: React.FC<MembershipProgrammeTermsOptionProps> = ({ closeMenu, onOpenTermsDialog }) => {
  return (
    <MenuItem
      onClick={() => {
        closeMenu?.();
        onOpenTermsDialog?.();
      }}
    >
      <span>{OPTION_LABEL}</span>
    </MenuItem>
  );
};

export default MembershipProgrammeTermsOption;
